
import '../../../style/header-sortable.scss'
export function createSortable () {
  return {
    functional: true,
    render (h, context) {
      return (<span class="header-sortable-wrapper">
        <i
          class={
            ['sort-caret layout layout-sort-up-normal', context.props.sortOrder]
          }
          on-click={
            (event) => {
              event.stopPropagation()
              context.props.handleSortChange()
            }
          }
        >
        </i>
      </span>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/sortable/index.js